<template>
  <div class="scene-view">
    <div
      id="engineContainer"
      class="engine-container"
      ref="engineContainer"
      :style="`visibility:${canvasVisible ? 'visible' : 'hidden'}`" />
    <EngineLoading
      v-if="isLoadingVisible"
      :percentage="percentage" />
  </div>
</template>

<script>
import EngineLoading from '@/components/Loading.vue'

import { isTemplateVersionConsistentWithEngine } from '@/utils/generalMethods'

// 需要设置坐标系和基点的数据类型
const SETCRS_DATA_TYPE = [0, 11, 15]

export default {
  data() {
    return {
      percentage: 0, // 进度条数值
      isLoadingVisible: true, // 是否显示进度条
      canvasVisible: false,

      isStartLoadDataSet: false
    }
  },
  components: {
    EngineLoading
  },
  mounted() {
    this.addEventListener()
  },
  beforeDestroy() {
    this.unloadAllDataSet()
    this.removeEventListener()
    this.isLoadingVisible = false

    window.removeEventListener('beforeunload', this.onBeforeUnload)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    addEventListener() {
      document.addEventListener('RESystemEngineCreated', this.onCreated)
      document.addEventListener('REDataSetLoadProgress', this.onProgress)
      document.addEventListener('REDataSetLoadFinish', this.onFinish)
      document.addEventListener('RESystemSelElement', this.onSelElement)
      document.addEventListener('RESystemUIEvent', this.onUIClick)

      window.addEventListener('beforeunload', this.onBeforeUnload)
      window.addEventListener('resize', this.onResize)
    },
    removeEventListener() {
      document.removeEventListener('RESystemEngineCreated', this.onCreated)
      document.removeEventListener('REDataSetLoadProgress', this.onProgress)
      document.removeEventListener('REDataSetLoadFinish', this.onFinish)
      document.removeEventListener('RESystemSelElement', this.onSelElement)
      document.removeEventListener('RESystemUIEvent', this.onUIClick)
    },
    initEngine() {
      window.BlackHole3D = window.BlackHole3D ? window.BlackHole3D : {}
      window.BlackHole3D.canvas = document.getElementById('engineCanvas')

      if (typeof window.BlackHole3D.RealBIMWeb === 'undefined') {
        window.BlackHole3D = window.CreateBlackHoleWebSDK(window.BlackHole3D)
      }
    },
    onCreated() {
      const timer = setInterval(() => {
        if (this.isEnginePreLoaded()) {
          clearInterval(timer)
          this.copyCanvas()

          this.$eventManage.fire('engineCreated', {})
        }
      }, 500)
    },
    onProgress(e) {
      if (!this.isStartLoadDataSet) return

      let percentage = e.detail.progress

      if (percentage < 10) {
        this.fromZeroFlag = true
      }
      if (percentage === 12 && this.fromZeroFlag) {
        percentage = 10
      }

      this.percentage = percentage
    },
    onFinish() {
      if (!this.isStartLoadDataSet) return

      this.canvasVisible = true
      this.isLoadingVisible = false

      this.$eventManage.fire('dataSetLoadFinish', {})

      // 解决模型加载完成后，键盘WASD不能控制引擎相机移动的问题
      setTimeout(() => {
        window.BlackHole3D.canvas.focus()
      }, 500)
    },
    onBeforeUnload() {
      window.BlackHole3D.releaseEngine()
    },
    onResize() {
      this.setCanvasSize()
    },
    async loadDataSetByVersion(dataSets) {
      this.isStartLoadDataSet = true

      const isVersionConsist = await isTemplateVersionConsistentWithEngine()
      const BlackHole3D = window.BlackHole3D
      if (!isVersionConsist) {
        const dataSetList = [
          {
            dataSetId: 'res_skybox',
            resourcesAddress: window.skyBoxUrl
          }
        ]
        BlackHole3D.Model.loadDataSet(dataSetList)

        BlackHole3D.Common.setMaxResMemMB(2000)
        BlackHole3D.Common.setExpectMaxInstMemMB(1900)
        BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
        BlackHole3D.Common.setPageLoadLev(2)
        this.$message.error('请升级SDK版本至3.2.0.3247之后的版本')
        return
      }

      let dataSetList = []
      dataSets.forEach(item => {
        let obj = {
          dataSetId: item.resId,
          resourcesAddress: this.getResourcesAddress(item),
          dataSetCRS: this.getDataSetCRS(item),
          engineOrigin: this.getEngineOrigin(item),
          dataSetCRSNorth: this.getDataSetCRSNorth(item),
          useTransInfo: true,
          transInfo: this.getTransInfo(item),
          useAssginVer: true,
          assginVer: item.assginVer,
          dataSetSGContent: item.context ? item.context : ''
        }

        dataSetList.push(obj)
      })
      BlackHole3D.Model.loadDataSet(dataSetList)

      BlackHole3D.Common.setMaxResMemMB(2000)
      BlackHole3D.Common.setExpectMaxInstMemMB(1900)
      BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
      BlackHole3D.Common.setPageLoadLev(2)
    },
    async loadVersionCompareResult(dataSets) {
      this.isStartLoadDataSet = true

      const isVersionConsist = await isTemplateVersionConsistentWithEngine()
      const BlackHole3D = window.BlackHole3D
      if (!isVersionConsist) {
        const dataSetList = [
          {
            dataSetId: 'res_skybox',
            resourcesAddress: window.skyBoxUrl
          }
        ]
        BlackHole3D.Model.loadDataSet(dataSetList)

        BlackHole3D.Common.setMaxResMemMB(2000)
        BlackHole3D.Common.setExpectMaxInstMemMB(1900)
        BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
        BlackHole3D.Common.setPageLoadLev(2)
        this.$message.error('请升级SDK版本至3.2.0.3247之后的版本')
        return
      }

      let dataSetList = []
      dataSets.forEach(item => {
        let obj = {
          dataSetId: item.resId,
          resourcesAddress: this.getResourcesAddress(item),
          dataSetCRS: this.getDataSetCRS(item),
          engineOrigin: this.getEngineOrigin(item),
          dataSetCRSNorth: this.getDataSetCRSNorth(item),
          useTransInfo: true,
          transInfo: this.getTransInfo(item),
          useAssginVer: true,
          assginVer: item.assginVer,
          useAssginVer2: true,
          assginVer2: item.assginVer2,
          dataSetSGContent: item.context ? item.context : ''
        }

        dataSetList.push(obj)
      })
      BlackHole3D.Model.loadDataSet(dataSetList)

      BlackHole3D.Common.setMaxResMemMB(2000)
      BlackHole3D.Common.setExpectMaxInstMemMB(1900)
      BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
      BlackHole3D.Common.setPageLoadLev(2)
      // prettier-ignore
      BlackHole3D.setViewMode(BlackHole3D.REVpTypeEm.BIM, BlackHole3D.REVpTypeEm.BIM, BlackHole3D.REVpRankEm.LR)
    },
    highLightElem(dataSetId, childNodeIds) {
      window.BlackHole3D.BIM.delAllSelElems()
      if (!childNodeIds.length) {
        window.BlackHole3D.BIM.setSelMode(0)
        window.BlackHole3D.BIM.addToSelDataSet(dataSetId)
        window.BlackHole3D.Camera.setCamLocateToDataSet(dataSetId, 1.0)
      } else {
        window.BlackHole3D.BIM.setSelMode(1)
        window.BlackHole3D.BIM.addToSelElems(dataSetId, childNodeIds)
        window.BlackHole3D.Camera.setCamLocateToElem(
          [
            {
              dataSetId: dataSetId,
              elemIdList: childNodeIds
            }
          ],
          1.0
        )
      }

      this.setSelElemsBlendAttr()
    },
    showDataSet(dataSetId) {
      window.BlackHole3D.BIM.resetElemAttr(dataSetId, [])
    },
    hideDataSet(dataSetId) {
      window.BlackHole3D.BIM.setElemAlpha(dataSetId, [], 0)
    },
    showElem(dataSetId, childNodeIds) {
      window.BlackHole3D.BIM.delAllSelElems()
      window.BlackHole3D.BIM.resetElemAttr(dataSetId, childNodeIds)
    },
    hideElem(dataSetId, childNodeIds) {
      window.BlackHole3D.BIM.delAllSelElems()
      window.BlackHole3D.BIM.setElemAlpha(dataSetId, childNodeIds, 0)
    },
    setSelElemsBlendAttr() {
      const BlackHole3D = window.BlackHole3D
      let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr()
      blendAttr.elemClr = new BlackHole3D.REColor(255, 0, 0, 200)
      blendAttr.clrWeight = 128
      blendAttr.alphaWeight = 200
      BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr)
    },
    onSelElement() {
      this.setSelElemsBlendAttr()

      let probeInfo = window.BlackHole3D.Probe.getCurCombProbeRet()
      let elemInfo = {
        elemId: probeInfo.elemId,
        elemType: probeInfo.elemType
      }
      this.$eventManage.fire('selElement', { elemInfo })
    },
    onUIClick(eventInfo) {
      let detail = eventInfo.detail
      let btnName = detail.btnname
      let btnState = detail.btnstate
      if (btnName.includes('Measure')) {
        window.BlackHole3D.BIM.delAllSelElems()
        window.BlackHole3D.Anchor.delAllAnc()
      }

      if (btnName.includes('UIClr_Style')) {
        this.$eventManage.fire('themeChange', { themeName: btnName })
      }

      if (btnName.includes('Catalog_Tree')) {
        if (btnState == 0) {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 1)
        } else {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 0)
        }
        this.$eventManage.fire('customBtnClick', { btnName })
      }

      if (btnName.includes('Attribute')) {
        if (btnState == 0) {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 1)
        } else {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 0)
        }
        this.$eventManage.fire('customBtnClick', { btnName })
      }
    },
    getResourcesAddress(dataSetInfo) {
      let resourcesAddress = ''
      if (window.isMinIO) {
        resourcesAddress = `${dataSetInfo.resourcesAddress}${dataSetInfo.resId}`
      } else {
        resourcesAddress = dataSetInfo.resourcesAddress
      }
      return resourcesAddress
    },
    getDataSetCRS(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null

      let crsConfig = dataSetInfo.coordinatesConfig
      if (crsConfig.coordinatesType === 'None') return null

      if (crsConfig.coordinatesType === 'CalibrationPoint') {
        let crsPoint = crsConfig.coordinatesPoint
        let crs = `ENU:${crsPoint.latitude},${crsPoint.longitude}`
        return crs
      } else {
        return crsConfig.coordinates
      }
    },
    getEngineOrigin(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null

      let engineOrigin = []
      let crsConfig = dataSetInfo.coordinatesConfig

      let origin = crsConfig.basePoint
      let originArray = []
      if (origin) {
        originArray = origin.split(',').map(Number)
      }

      if (crsConfig.coordinatesType === 'CalibrationPoint') {
        let crsPoint = crsConfig.coordinatesPoint
        let point = crsPoint.coordinates
        let pointArray = []
        if (point) {
          pointArray = point.split(',').map(Number)
        } else {
          pointArray = [0, 0, 0]
        }

        if (originArray.length) {
          originArray.forEach((item, index) => {
            let result = item - pointArray[index]
            engineOrigin.push(result)
          })
        } else {
          engineOrigin = pointArray
        }
      } else {
        engineOrigin = originArray
      }

      if (engineOrigin.length) {
        return engineOrigin
      } else {
        return null
      }
    },
    getDataSetCRSNorth(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null
      let crsConfig = dataSetInfo.coordinatesConfig
      if (crsConfig.northAngle) {
        return Number(crsConfig.northAngle)
      } else {
        return null
      }
    },
    getTransInfo(dataSetInfo) {
      let sacle = dataSetInfo.scale.split(' ').map(Number)
      let rotate = dataSetInfo.rotate.split(' ').map(Number)
      let translation = dataSetInfo.translation.split(' ').map(Number)
      let transInfo = [sacle, rotate, translation]
      return transInfo
    },
    setCanvasSize() {
      const domRef = this.$refs.engineContainer
      if (domRef) {
        window.BlackHole3D.m_re_em_window_width = domRef.clientWidth
        window.BlackHole3D.m_re_em_window_height = domRef.clientHeight
      }
    },
    unloadAllDataSet() {
      window.BlackHole3D.Model.unloadAllDataSet()
    },
    addCustomBtn(uiID, stateParList, activeStateId) {
      let btnInfo = new window.BlackHole3D.REUIBtnInfo()
      btnInfo.uiID = uiID
      btnInfo.activeStateId = activeStateId

      let tempStateParList = stateParList.map(item => {
        let statePar = new window.BlackHole3D.REUIBtnStateInfo()
        statePar.hintText = item.hintText
        statePar.texPath = item.texPath
        return statePar
      })

      btnInfo.stateParList = tempStateParList
      window.BlackHole3D.Graphics.createSysPanelBtn(btnInfo)
    },
    copyCanvas() {
      const engineContainer = this.$refs.engineContainer
      const engineCanvas = document.getElementById('engineCanvas')
      engineContainer.append(engineCanvas)

      this.setCanvasSize()
    },
    isEnginePreLoaded() {
      let isPreLoaded = false
      const engineCanvas = document.getElementById('engineCanvas')
      const classList = engineCanvas.classList
      if (classList.contains('is-loaded')) {
        isPreLoaded = true
      }
      return isPreLoaded
    },
    isEngineCanvasExist() {
      let isExist = false
      const engineCanvas = document.getElementById('engineCanvas')
      if (engineCanvas) {
        isExist = true
      } else {
        isExist = false
      }
      return isExist
    },
    createEngineCanvas() {
      const engingCanvasDom = document.createElement('canvas')
      engingCanvasDom.id = 'engineCanvas'
      engingCanvasDom.classList.add('engine-canvas-box')
      // prettier-ignore
      engingCanvasDom.oncontextmenu = e => { e.preventDefault() }
      engingCanvasDom.tabIndex = '1'

      const engineContainer = document.getElementById('engineContainer')
      engineContainer.append(engingCanvasDom)
    }
  }
}
</script>

<style lang="less" scoped>
.scene-view {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--eng-loading-bgColor);

  .engine-container {
    height: 100%;
    :deep(.engine-canvas-box) {
      outline: none;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
